import { useQuery } from '@tanstack/react-query';

import { getClientProducts } from 'api/generated/client-products/client-products';
import type { ClientProductDto } from 'api/generated/schemas';

import type {
  UseQueryResult,
} from '@tanstack/react-query';

interface UseClientProductsListArgs {
  userId: string | undefined;
  clientId: string | number | undefined;
  enabled?: boolean;
}

export const clientProductsKeys = {
  all: ['client-products'] as const,
  list: (clientId: string | number | undefined) =>
    [...clientProductsKeys.all, 'list', clientId] as const,
};

export const useClientProductsList = ({
  userId,
  clientId,
  enabled = true,
}: UseClientProductsListArgs): UseQueryResult<ClientProductDto[], Error> =>
  useQuery({
    queryKey: clientProductsKeys.list(clientId),
    queryFn: async () =>
      getClientProducts(userId ?? '', Number(clientId), {
        size: 1000,
        sort: ['id,asc'],
      }),
    enabled: enabled && !!userId && !!clientId,
    staleTime: 60000,
  });
